import { useMemo } from 'react'
import { Option, SelectProps } from '@organisms/Select'
import {
  FilterProps,
  FilterTypes,
} from '@templates/ListPageLayout/Filters/Filter'
import { useGetCourseAuthorsQuery } from '@services/courseAuthors'

export { SCHOOL_VALUE } from '@utils/courseAuthor'

const useCourseAuthorFilter = (
  fieldNameForSubmit?: string
): FilterProps<SelectProps> => {
  const { data: authors = [], isLoading } = useGetCourseAuthorsQuery()

  const options = useMemo<Option[]>(
    () =>
      authors.map((author) => ({
        value: author.id,
        label: author.name,
      })),
    [authors]
  )

  return {
    options,
    length: options.length,
    isLoading,
    placeholder: 'Автор курса',
    fieldName: 'courseAuthor',
    fieldNameForSubmit: fieldNameForSubmit || 'courseAuthorId',
    filterType: FilterTypes.SELECT_SEARCH,
    dropdownWidth: 350,
  }
}

export default useCourseAuthorFilter
